module.exports = __webpack_public_path__ + "img/location-purple.60924714.svg";